import { ListItem } from "@material-ui/core";
import styled from "styled-components/macro";

export const PickerListItem = styled(ListItem)<{ disabled?: boolean }>`
  && {
    background-color: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.gray78};
    border-radius: ${({ theme }) => theme.radii[2]}px;
    box-shadow: ${({ theme }) => theme.shadows[2]};
    color: ${({ disabled, theme }) =>
      disabled ? theme.colors.gray78 : theme.colors.primary};
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    margin-bottom: ${({ theme }) => theme.space[1]}px;
    padding: ${({ theme }) => theme.space[2]}px;
    text-align: center;
  }
  span {
    font-weight: ${({ theme }) => theme.fontWeights.medium};
  }
`;
